import { render, staticRenderFns } from "./GitlabSaveModal.vue?vue&type=template&id=38247121&"
import script from "./GitlabSaveModal.vue?vue&type=script&lang=js&"
export * from "./GitlabSaveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GitlabSaveModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/GitlabSaveModal.vue
// module id = 1687
// module chunks = 1